export default {
  custom_option: 'Custom',
  zero_option: 'No tip',
};
